export const theme = {
  mutedTextColor: Styles.color.grey.one,
};
